module.exports = __webpack_public_path__ + "img/masscoms_2.37b20654.png";